import React from 'react';

import fetch from '../../fetch';

import moment from 'moment';

import utils from '../../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},
    {key:'studentNo', label: '学号', width: 160},
    {key:'name', label: '姓名'},
    {key:'sex', label: '性别', render: (value) => value === 1 ? '男' : '女'},
    {key:'orgName', label: '所属部门'},
    {key:'classesName', label: '班级'},
    {key:'classGrade', label: '年级'},
    {key:'yearSystem', label: '学制'},
    {key:'studentPropertyName', label: '学生性质'}
])

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
 const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('second/credit/class/auth/student/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

const querySearchByName = (keywords ={}) => {
    return fetch.post('second/credit/class/auth/classes/find', keywords)
    .then(response => {
        var list = (response.payload.data || []).map(d => ({
            value: d.classesId ,
            label: d.classesName
        }));
        return list;
    });
}

export default {
    columns,
    querySearchByName,
    querySearch,
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    getSelectionData,
}